//
// ログイン情報
//
import * as http from '@/libs/http'

//
// ストア
//
export default {
  namespaced: true,

  state: {
    // ユーザID
    id: 0,

    // ユーザ名
    name: ''
  },

  getters: {
    // ユーザID
    userID (state) {
      return state.id
    },

    // ユーザ名
    userName (state) {
      return state.name
    },

    // ログイン済み
    logined (state) {
      return state.id > 0
    }
  },

  mutations: {
    // ログイン情報を設定
    setLogin (state, user) {
      state.id = user.id
      state.name = user.name
    }
  },

  actions: {
    //
    // ログイン
    //
    async login ({ commit }, login) {
      // login = { email: 'a@b.c', password: 'password' }
      const data = await http.request(async api => {
        const resp = await api.post('users/auth', {
          login
        })
        if (resp.status !== http.OK) {
          return new http.StatusError(resp)
        }

        return resp.data
      })
      if (data === http.FAILED) {
        return { ok: false, reasons: [] }
      }
      if (!data.ok) {
        // ログインに失敗した
        return data
      }

      // ログインに成功した
      commit('setLogin', data.user)
      return { ok: true }
    },

    //
    // ログアウト
    //
    async logout ({ commit }) {
      commit('setLogin', { userid: 0, username: '' })
    }
  }
}
